import ContactHeroSection from "../components/ContactHeroSection";
import ContactUs from "../components/ContactUs";

function Contact(){
    return(
        <>
            <ContactHeroSection />
            <ContactUs/>
        </>
    );
}

export default Contact;